// removed by extract-text-webpack-plugin
module.exports = {"ratingContainer":"ratingContainer__1zFxi","rating":"rating__M673J","ratingTitle":"ratingTitle__EN3zK","star":"star__OZN7a","star-rating":"star-rating__UH6sF"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/Rating/style.scss
// module id = 6Xo/
// module chunks = 0